import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Code from './icon-code.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Code {...validProps} />;
}
SvgComponent.iconName = 'code';

/**
 * @deprecated This is a legacy icon
 */
export const CodeIcon = svgIconWrapper(SvgComponent);
